import { Button } from "@shared/ui/Button";

import {
  Col,
  Divider,
  Drawer,
  Dropdown,
  Flex,
  InputNumber,
  Menu,
  Modal,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { Table } from "@shared/ui";
import { ColumnSortUI } from "@shared/ui/filters/ColumnSortUI";
import { ColumnFilterWrapper } from "@shared/ui/filters/ColumnFilterWrapper";
import DateRangeFilter from "@shared/ui/filters/DateRangeFilter";
import Search from "antd/es/transfer/search";

import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  InfoCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.scss";

import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";

import {
  BreifInfluencerV2StatusEnum,
  SORT_ORDER,
} from "@entities/brief/lib/constants";
import {
  IAssignedPOC,
  IBriefInfluencerSearchRequestV2WithoutBriefId,
  IBriefInfluencerV2,
  IInfluencerContact,
} from "@shared/lib/types/briefInfluencerV2";
import { useEffect, useState } from "react";

import { SocialMediaInfluencerComp } from "@features/socialMediaInfluencer/SocialMediaInfluencerComp";

import { useAuth } from "@entities/auth";
import { useUpdateEstView } from "@entities/brief/lib/hooks/useAddEstViews";
import { useUpdatePaymentTerms } from "@entities/brief/lib/hooks/useAddPaymentTerms";
import { useAssignBriefPoc } from "@entities/brief/lib/hooks/useAssignBriefPoc";
import { useGetBriefInfluencerSearchFacetsWithoutBriefId } from "@entities/brief/lib/hooks/useGetBriefInfluencerSearchFacetsWithoutBriefId";
import { useGetBriefInfluencersV2withoutBriefId } from "@entities/brief/lib/hooks/useGetBriefInfluencersV2withoutBriefId";
import { SelectContact } from "@entities/brief/ui/Influencer/v2/SelectContact";
import { AssignPricingModal } from "@features/assignPricingModal";
import { BrandCommercial } from "@features/brandCommercials/BrandCommercials";
import { BriefCreatorColumn } from "@features/breifCreatorColumn/BriefCreatorColumn";
import BriefContactFilter from "@features/BriefContactFilter/BriefContactFilter";
import { BriefInfluencerCommercials } from "@features/briefInfluencerCommercials/BriefInfluencerCommercials";
import { BriefPocFilter } from "@features/briefPocFilter/BriefPocFilter";
import { InfluencerCommercial } from "@features/infleuncerCommercials/InfluencerCommercials";
import { ToastService } from "@shared/lib/services";
import { formatData } from "@shared/lib/utils/formatData";
import { BriefBrandFilter } from "@shared/ui/filters/BriefBrandFilter";
import InfluencerCommercialFilter from "@shared/ui/filters/InfluencerCommercialFilter.tsx";
import SelectInput from "@shared/ui/SelectInput";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { ColumnsType } from "antd/es/table";
import { format } from "date-fns";
const { Title } = Typography;

export const BriefDiscoveryTracking = () => {
  const { briefId, setBriefIdOnly, brief } = useBriefStore();

  const [brandId, setBrandId] = useState<string>("");

  const [selectedBriefIds, setSelectedBriefIds] = useState<string>("");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [deliverableModalProps, setDeliverableModalProps] = useState<{
  //   visible: boolean;
  //   deliverableId?: string;
  //   briefId: string;
  //   briefInfluencerIds: string[];
  //   type: "view" | "create";
  // }>({
  //   visible: false,
  //   deliverableId: "",
  //   briefId: "",
  //   briefInfluencerIds: [],
  //   type: "create",
  // });
  const [conatcsModalProps, setContactsModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string;
    conatcts: IInfluencerContact[];
    addContactOnly?: boolean;
    initialContact: IInfluencerContact | null;
    creatorInfo:
      | {
          name: string;
          dp: string;
          rating: number;
        }
      | undefined;
  }>({
    visible: false,
    briefInfluencerId: "",
    creatorInfo: undefined,
    conatcts: [],
    addContactOnly: false,
    initialContact: null,
  });

  const [infCommercialsModalProps, setInfluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new" | "create";
  }>({
    visible: false,
    type: "create",
  });
  const [brandCommercialsModalProps, setBrandluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
  }>({
    visible: false,
  });

  const [paymnetTermsProps, setpaymnetTermsProps] = useState<{
    briefInfluencerId: string;
    paymentTerms: string;
  }>({
    briefInfluencerId: "",
    paymentTerms: "",
  });
  const [estViewsProps, setestViewsProps] = useState<{
    briefInfluencerId: string;
    estViews: number;
  }>({
    briefInfluencerId: "",
    estViews: 0,
  });

  const [page, setPage] = useState(1); // default if not present
  const [pageSize, setPageSize] = useState(50);
  const [filters, setFilters] =
    useState<IBriefInfluencerSearchRequestV2WithoutBriefId>({
      page: 1,
      limit: 10,
      isBrandDeclined: undefined,
      isBrandNewCostPending: undefined,
      isConfirmationSent: undefined,
      isConfirmed: undefined,
      isCreatorDeclined: undefined,
      isCreatorOnboardPending: undefined,
      isDeliverablesPending: undefined,
      isInitialInfluencerCostPending: undefined,
      isNewCommericalRequested: undefined,
      searchQuery: "",

      isPrimaryContactAdded: undefined,
      statuses: [BreifInfluencerV2StatusEnum.Shortlisted],
    });

  const { page: PageNo, ...restFilters } = filters;
  const [selectedInfluencer, setSelectedInfluencer] = useState<{
    visible: boolean;
    props?: {
      username: string;
      platform: string;
      toOpenInfluencer?: boolean;
      creatorInfo: {
        name?: string;
        image?: string;
        username?: string;
      };
    };
  }>({ visible: false, props: undefined });

  const [pricingPocModalProps, setPricingPocModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string[];
    selectedAssignedTo?: IAssignedPOC["assignedTo"];
  }>({
    visible: false,
    briefInfluencerId: [],
    selectedAssignedTo: undefined,
  });

  const { assignPricingPoc, isAssigning, isAssigned } =
    useAssignBriefPoc(briefId);

  const [selectedDeliverableForAttach, setSelectedDeliverableForAttach] =
    useState<{ _id: string } | null>(null);
  // const {
  //   attachBriefDeliverable,
  //   isAttaching,
  //   isAttached,
  //   attachBriefDeliverableError,
  // } = useAttachBriefDeliverable(briefId);

  const openPricingPocModal = (
    briefInfluencerId: string[] | string,
    assignedTo?: IAssignedPOC["assignedTo"]
  ) => {
    setPricingPocModalProps({
      visible: true,
      briefInfluencerId: Array.isArray(briefInfluencerId)
        ? briefInfluencerId
        : [briefInfluencerId],
      selectedAssignedTo: assignedTo,
    });
  };

  useEffect(() => {
    handlePageChange(1, pageSize);
  }, [filters]);

  useEffect(() => {
    if (isAssigned) {
      setPricingPocModalProps({
        visible: false,
        briefInfluencerId: [],
        selectedAssignedTo: undefined,
      });
      ToastService.success("Pricing POC assigned successfully");
    }
  }, [isAssigned]);

  // useEffect(() => {
  //   if (isAttached) {
  //     ToastService.success("Deliverable attached successfully.");
  //     setDeliverableModalProps({
  //       visible: false,
  //       type: "create",
  //       deliverableId: "",
  //       briefInfluencerIds: [],
  //       briefId: "",
  //     });
  //     setSelectedDeliverableForAttach(null);
  //   } else if (attachBriefDeliverableError) {
  //     ToastService.error(attachBriefDeliverableError?.message);
  //   }
  // }, [isAttached, attachBriefDeliverableError]);

  const { briefInfluencers, isError, isFetching, refetch } =
    useGetBriefInfluencersV2withoutBriefId({
      ...filters,
      page: page,
      limit: pageSize,
      brandIds: brandId ? [brandId] : undefined,
      briefId: selectedBriefIds ? selectedBriefIds : undefined,
    });

  const { beUser } = useAuth();

  const { searchFacets } = useGetBriefInfluencerSearchFacetsWithoutBriefId([
    BreifInfluencerV2StatusEnum.Shortlisted,
  ]);

  const { updatePaymentTerms, isUpdating } = useUpdatePaymentTerms(
    undefined,
    () => {
      refetch();
      setpaymnetTermsProps({
        briefInfluencerId: "",
        paymentTerms: "",
      });
    }
  );

  const { updateEstView, isUpdating: isEstViewUpdating } = useUpdateEstView(
    undefined,
    () => {
      refetch();
      setestViewsProps({
        briefInfluencerId: "",
        estViews: 0,
      });
    }
  );

  if (isError) {
    return (
      <Row justify={"center"}>
        <Title> Invalid Id</Title>
      </Row>
    );
  }

  const handlePageChange = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const BriefPricingPOCOptions = [
    ...(searchFacets?.assignedPricingPocV2
      ? searchFacets?.assignedPricingPocV2
      : []),
    {
      _id: "unassigned",
      user: {
        _id: "unassigned",
        firstName: "Unassigned",
        lastName: "",
      },
    },
  ];

  const columns: ColumnsType<IBriefInfluencerV2> = [
    {
      title: "Creator",
      dataIndex: "influencerName",
      key: "creator",
      fixed: "left",
      width: 80,
      className: styles.actionsColumn,
      render: (text, record) => (
        <BriefCreatorColumn
          influencerId={record.influencerId}
          influencerName={record.influencerName}
          username={record.socialMedia?.username}
          platform={record.socialMedia?.platform}
          profilePicUrl={record.socialMedia?.profilePicUrl}
          link={record.socialMedia?.link}
          isCreatorDeclined={record.isCreatorDeclined}
          isBrandDeclined={record.isBrandDeclined}
          creatorDeclinedReason={record.creatorDeclinedReason}
          brandDeclinedReason={record.brandDeclinedReason}
        />
      ),
    },
    {
      title: "Brief Info",
      render: (text, record) => (
        <Flex vertical gap={2}>
          <TextWithTooltip text={record.brief?.name} limit={15} />
          <TextWithTooltip text={record.brand?.name} limit={15} />
        </Flex>
      ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefBrandFilter
            props={props}
            selectedBrandId={brandId}
            selectedBriefId={selectedBriefIds}
            handlePropsChange={(props) => {
              setBrandId(props.brandId || "");
              setSelectedBriefIds(props.briefId || "");
            }}
          />
        );

        // Return null for other field types to avoid undefined filter dropdown
      },
    },
    {
      title: "Followers",
      dataIndex: "followers",
      key: "followers",
      width: 100,
      filterCount: filters.sortByFollowers ? 1 : 0,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => (
        <ColumnFilterWrapper
          title="Followers"
          confirm={props.confirm}
          close={props.close}
          hasSort={true}
          hasFilter={false}
          sortActive={!!filters.sortByFollowers}
          sortDirection={
            filters.sortByFollowers === SORT_ORDER.ASCEND ? "asc" : "desc"
          }
          onReset={() => {
            setFilters((prev) => {
              const next = { ...prev };
              delete next.sortByFollowers;
              return next;
            });
            props.confirm();
          }}
          onApply={() => props.confirm()}
        >
          <ColumnSortUI
            sortActive={!!filters.sortByFollowers}
            sortDirection={
              filters.sortByFollowers === SORT_ORDER.ASCEND ? "asc" : "desc"
            }
            onSortChange={(dir) => {
              setFilters((prev) => {
                const next = { ...prev };
                if (!dir) {
                  delete next.sortByFollowers;
                } else {
                  next.sortByFollowers =
                    dir === "asc" ? SORT_ORDER.ASCEND : SORT_ORDER.DESCEND;
                }
                return {
                  ...next,
                  sortByUpdatedAt: undefined,
                  sortByCreatedAt: undefined,
                };
              });
              props.confirm();
            }}
          />
        </ColumnFilterWrapper>
      ),
      render: (followers: number) => (
        <span>{followers ? formatData(followers, "a") : "--"}</span>
      ),
    },

    {
      title: "Contact",
      key: "contact",
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefContactFilter
            {...props}
            filters={filters}
            setFilters={setFilters}
          />
        );
      },
      render: (_, record: IBriefInfluencerV2) => {
        const renderDropdown = () => {
          return (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item>
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      onClick={() => {
                        record?.influencer?.contacts &&
                        record?.influencer?.contacts?.length > 0
                          ? setContactsModalProps({
                              initialContact: record?.primaryContact || null,
                              addContactOnly: true,
                              visible: true,
                              briefInfluencerId: record._id,
                              conatcts: record?.influencer?.contacts || [],
                              creatorInfo: {
                                name: record.socialMedia.username,
                                dp: record.socialMedia?.profilePicUrl,
                                rating: record.influencer?.avgReview || 0,
                              },
                            })
                          : setSelectedInfluencer({
                              visible: true,
                              props: {
                                username: record.socialMedia?.username,
                                platform: record.socialMedia?.platform || "",
                                creatorInfo: {
                                  name: record.influencerName,
                                  image: record.socialMedia?.profilePicUrl,
                                  username: record.socialMedia?.username,
                                },
                                toOpenInfluencer: true,
                              },
                            });
                      }}
                    >
                      Change Contact
                    </Button>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click", "hover"]}
              placement="bottomRight"
            >
              <Button icon={<MoreOutlined />} type="text" />
            </Dropdown>
          );
        };
        if (!record?.isPrimaryContactAdded) {
          return (
            <Button
              size="small"
              onClick={() =>
                record?.influencer?.contacts &&
                record?.influencer?.contacts?.length > 0
                  ? setContactsModalProps({
                      initialContact: record?.primaryContact || null,
                      addContactOnly: true,
                      visible: true,
                      briefInfluencerId: record._id,
                      conatcts: record?.influencer?.contacts || [],
                      creatorInfo: {
                        name: record.socialMedia.username,
                        dp: record.socialMedia?.profilePicUrl,
                        rating: record.influencer?.avgReview || 0,
                      },
                    })
                  : setSelectedInfluencer({
                      visible: true,
                      props: {
                        username: record.socialMedia?.username,
                        platform: record.socialMedia?.platform || "",
                        toOpenInfluencer: true,
                        creatorInfo: {
                          name: record.influencerName,
                          image: record.socialMedia?.profilePicUrl,
                          username: record.socialMedia?.username,
                        },
                      },
                    })
              }
            >
              Add Contact
            </Button>
          );
        }
        if (record?.primaryContact?.agencyUser) {
          return (
            <div className={styles.aTile}>
              <Space>
                <span className={styles.cName}>
                  {record?.primaryContact?.agency?.name}
                </span>
                <span className={styles.aRole}>Agency</span>
                {renderDropdown()}
              </Space>
              <Space>
                <span className={styles.cType}>
                  {record?.primaryContact?.agencyUser?.name}
                </span>
                /
                <span className={styles.numb}>
                  {record?.primaryContact?.agencyUser?.phoneNumber
                    ? `${record?.primaryContact?.agencyUser?.countryCode} ${record?.primaryContact?.agencyUser?.phoneNumber}`
                    : record?.primaryContact?.agencyUser?.emailId}
                </span>
              </Space>
            </div>
          );
        }

        return (
          <div className={styles.aTile}>
            <Space>
              <span className={styles.cName}>
                {record?.primaryContact?.name}
              </span>
              {renderDropdown()}
            </Space>
            <Space>
              <span className={styles.cType}>
                {record?.primaryContact?.type}
              </span>
              /
              <span className={styles.numb}>
                {record?.primaryContact?.phoneNumber
                  ? `${record?.primaryContact?.countryCode} ${record?.primaryContact?.phoneNumber}`
                  : record?.primaryContact?.emailId}
              </span>
            </Space>
          </div>
        );
      },
    },
    {
      title: "Pricing POC",
      key: "pricingPoc",
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefPocFilter
            {...props}
            filters={filters}
            setFilters={setFilters}
            pocOptions={BriefPricingPOCOptions}
          />
        );
      },
      render: (_, record) => {
        if (record.assignedPricingPocV2) {
          return (
            <Space>
              <span>
                {record.assignedPricingPocV2?.assignedToUser?.firstName}{" "}
                {record.assignedPricingPocV2?.assignedToUser?.lastName}
              </span>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => {
                          openPricingPocModal(
                            record._id,
                            record.assignedPricingPocV2?.assignedToUser
                          );
                        }}
                      >
                        Change Pricing POC
                      </Button>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click", "hover"]}
                placement="bottomRight"
              >
                <Button icon={<MoreOutlined />} type="text" />
              </Dropdown>
            </Space>
          );
        }
        return (
          <Button
            size="small"
            onClick={() =>
              openPricingPocModal(
                record._id,
                record.assignedPricingPocV2?.assignedToUser
              )
            }
          >
            Assign Pricing POC
          </Button>
        );
      },
    },

    {
      title: "Payment Terms",
      key: "paymentTerms",
      width: 120,
      render: (_: any, record: IBriefInfluencerV2) => {
        const isEditingField =
          paymnetTermsProps.briefInfluencerId === record._id;
        if (isEditingField) {
          const addonAfter = (
            <Space>
              <Button
                icon={<CheckOutlined />}
                type="text"
                style={{ padding: 0 }}
                size="small"
                loading={isUpdating}
                onClick={() =>
                  updatePaymentTerms({
                    briefInfluencerId: record._id,
                    paymentTerms: paymnetTermsProps.paymentTerms,
                  })
                }
              />
              <Button
                icon={<CloseOutlined />}
                type="text"
                size="small"
                style={{ padding: 0 }}
                onClick={() =>
                  setpaymnetTermsProps({
                    briefInfluencerId: "",
                    paymentTerms: "",
                  })
                }
              />
            </Space>
          );
          return (
            <Space>
              <div style={{ width: "150px" }}>
                <SelectInput
                  placeholder="Select payment terms"
                  allowClear
                  showSearch
                  onSearch={() => {}}
                  value={paymnetTermsProps.paymentTerms}
                  isFetching={false}
                  dropdownOpen={dropdownOpen}
                  setDropdownOpen={setDropdownOpen}
                  options={
                    searchFacets?.paymentTerms?.map((item) => ({
                      label: item._id,
                      value: item._id,
                    })) || []
                  }
                  onchange={(value) =>
                    setpaymnetTermsProps({
                      briefInfluencerId: record._id,
                      paymentTerms: value as string,
                    })
                  }
                  newItem={{
                    placeholder: "Enter a new payment term",
                    addNewItem: (item) =>
                      setpaymnetTermsProps({
                        briefInfluencerId: record._id,
                        paymentTerms: item,
                      }),
                    addButtonText: "Add payment term",
                  }}
                />
              </div>
              {addonAfter}
            </Space>
          );
        }

        return (
          <div
            className={styles.editableCell}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span
              onClick={() =>
                setpaymnetTermsProps({
                  paymentTerms: record?.paymentTerms || "",
                  briefInfluencerId: record._id,
                })
              }
            >
              {" "}
              {record?.paymentTerms || "--"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Est. Views",
      key: "estViews",
      width: 120,
      render: (_: any, record: IBriefInfluencerV2) => {
        const isEditingField = estViewsProps.briefInfluencerId === record._id;
        if (isEditingField) {
          const addonAfter = (
            <Space>
              <Button
                icon={<CheckOutlined />}
                type="text"
                style={{ padding: 0 }}
                size="small"
                loading={isEstViewUpdating}
                onClick={() =>
                  updateEstView({
                    briefInfluencerId: record._id,
                    estViews: estViewsProps.estViews,
                  })
                }
              />
              <Button
                icon={<CloseOutlined />}
                type="text"
                size="small"
                style={{ padding: 0 }}
                onClick={() =>
                  setestViewsProps({
                    briefInfluencerId: "",
                    estViews: 0,
                  })
                }
              />
            </Space>
          );
          return (
            <Space>
              <div>
                <InputNumber
                  value={estViewsProps.estViews}
                  onChange={(value) =>
                    setestViewsProps({
                      briefInfluencerId: record._id,
                      estViews: (value as number) || 0,
                    })
                  }
                />
              </div>
              {addonAfter}
            </Space>
          );
        }

        return (
          <div
            className={styles.editableCell}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span
              onClick={() =>
                setestViewsProps({
                  estViews: record?.estViews || 0,
                  briefInfluencerId: record._id,
                })
              }
            >
              {" "}
              {record?.estViews ? formatData(record?.estViews, "a") : "--"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Influencer Commercials",
      key: "influencerCommercials",
      hidden: beUser?.demoMode,
      render: (_, record) => {
        if (record.isBrandDeclined) {
          return (
            <Tooltip title={record?.brandDeclinedReason}>
              <Button
                type="link"
                danger
                icon={<InfoCircleOutlined />}
                className={styles.tooltipButton}
                size="small"
              >
                Brand Declined
              </Button>
            </Tooltip>
          );
        }
        if (record.isCreatorDeclined) {
          return (
            <Tooltip title={record?.creatorDeclinedReason}>
              <Button
                type="link"
                danger
                icon={<InfoCircleOutlined />}
                className={styles.tooltipButton}
                size="small"
              >
                Creator Declined
              </Button>
            </Tooltip>
          );
        }
        if (record.isCreatorOnboardPending) {
          return (
            <Tooltip title="Onboarding Pending">
              <Button
                type="link"
                icon={<InfoCircleOutlined />}
                style={{ color: "var(--info-color)" }}
                className={styles.tooltipButton}
                size="small"
              >
                Onboarding Pending
              </Button>
            </Tooltip>
          );
        }
        if (record.isDeliverablesPending) {
          return (
            <Tooltip title="Deliverables Pending">
              <Button
                type="link"
                icon={<InfoCircleOutlined />}
                style={{ color: "var(--info-color)" }}
                className={styles.tooltipButton}
                size="small"
              >
                Deliverables Pending
              </Button>
            </Tooltip>
          );
        }
        if (!record.isPrimaryContactAdded) {
          return (
            <Button
              size="small"
              onClick={() => {
                setContactsModalProps({
                  initialContact: record?.primaryContact || null,
                  visible: true,
                  briefInfluencerId: record._id,
                  conatcts: record?.influencer?.contacts || [],
                  creatorInfo: {
                    name: record.socialMedia.username,
                    dp: record.socialMedia?.profilePicUrl,
                    rating: record.influencer?.avgReview || 0,
                  },
                });
              }}
            >
              Add Commercials
              {/* Verify Contact */}
            </Button>
          );
        }

        return <BriefInfluencerCommercials briefInfluencer={record} />;
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <InfluencerCommercialFilter
            type="discovery"
            props={props}
            placeholder={`Select Date Range`}
            selectedRange={filters.influencerCost?.date}
            selectedStageInitial={filters.influencerCost?.offerStatus || []}
            handlePropsChange={(props) => {
              setFilters((prev) => ({
                ...prev,
                influencerCost: {
                  ...prev.influencerCost,
                  date: props.range,
                  offerStatus: props.stage,
                  createdByType: props.createdByType,
                },
              }));
            }}
          />
        );

        // Return null for other field types to avoid undefined filter dropdown
      },
    },
    {
      title: "Deliverables",
      key: "deliverables",
      width: 120,
      render: (_, record) => {
        if (record.isDeliverablesPending) {
          return (
            // <Button
            //   size="small"
            //   onClick={() =>
            //     setDeliverableModalProps({
            //       visible: true,
            //       briefId: record.briefId,
            //       deliverableId: "",
            //       type: "create",
            //       briefInfluencerIds: [record._id],
            //     })
            //   }
            // >
            //   Add Deliverables
            // </Button>
            <span>No Deliverables</span>
          );
        }

        if (
          record?.deliverableV2 &&
          record.deliverableV2.purchaseItems &&
          record.deliverableV2.purchaseItems.length > 0
        ) {
          return (
            <Flex align="center" gap={2}>
              <span className={styles.deliverableSummary}>
                <TextWithTooltip
                  text={
                    record?.deliverableV2?.name ||
                    `Package - ${
                      record?.deliverableV2?.setNumber || ""
                    }`
                  }
                  limit={15}
                />{" "}
              </span>
              {/* <Flex vertical>
                <Button
                  type="link"
                  size="small"
                  className={styles.deliverableView}
                  onClick={() =>
                    setDeliverableModalProps({
                      visible: true,
                      briefId: record.briefId,
                      deliverableId:
                        record?.deliverableV2?._id || "",
                      type: "view",
                      briefInfluencerIds: [record._id],
                    })
                  }
                >
                  View
                </Button>
              </Flex> */}
            </Flex>
          );
        }
        return <div>..</div>;
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      filterCount: (filters.sortByCreatedAt ? 1 : 0) + (filters.createdAt?.from || filters.createdAt?.to ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const sortUI = (
          <ColumnSortUI
            sortActive={!!filters.sortByCreatedAt}
            sortDirection={
              filters.sortByCreatedAt === SORT_ORDER.ASCEND
                ? "asc"
                : filters.sortByCreatedAt === SORT_ORDER.DESCEND
                  ? "desc"
                  : undefined
            }
            onSortChange={(dir) => {
              setFilters((prev) => ({
                ...prev,
                sortByCreatedAt:
                  dir === "asc"
                    ? SORT_ORDER.ASCEND
                    : dir === "desc"
                      ? SORT_ORDER.DESCEND
                      : undefined,
                sortByUpdatedAt: undefined,
                sortByFollowers: undefined,
              }));
            }}
            sortAscLabel="Earliest first"
            sortDescLabel="Latest first"
          />
        );
        return (
          <DateRangeFilter
            title="Created At"
            before={sortUI}
            props={props}
            placeholder="Select Date Range"
            selectedRange={filters.createdAt}
            handlePropsChange={(rangeProps) => {
              setFilters((prev) => ({
                ...prev,
                createdAt: rangeProps.range,
              }));
            }}
          />
        );
      },
      render: (createdAt: string) => (
        <span>
          {createdAt ? format(new Date(createdAt), "dd/MM/yyyy") : "--"}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 100,
      filterCount: (filters.sortByUpdatedAt ? 1 : 0) + (filters.updatedAt?.from || filters.updatedAt?.to ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const sortUI = (
          <ColumnSortUI
            sortActive={!!filters.sortByUpdatedAt}
            sortDirection={
              filters.sortByUpdatedAt === SORT_ORDER.ASCEND
                ? "asc"
                : filters.sortByUpdatedAt === SORT_ORDER.DESCEND
                  ? "desc"
                  : undefined
            }
            onSortChange={(dir) => {
              setFilters((prev) => ({
                ...prev,
                sortByUpdatedAt:
                  dir === "asc"
                    ? SORT_ORDER.ASCEND
                    : dir === "desc"
                      ? SORT_ORDER.DESCEND
                      : undefined,
                sortByCreatedAt: undefined,
                sortByFollowers: undefined,
              }));
            }}
            sortAscLabel="Earliest first"
            sortDescLabel="Latest first"
          />
        );
        return (
          <DateRangeFilter
            title="Updated At"
            before={sortUI}
            props={props}
            placeholder="Select Date Range"
            selectedRange={filters.updatedAt}
            handlePropsChange={(rangeProps) => {
              setFilters((prev) => ({
                ...prev,
                updatedAt: rangeProps.range,
              }));
            }}
          />
        );
      },
      render: (updatedAt: string) => (
        <span>
          {updatedAt ? format(new Date(updatedAt), "dd/MM/yyyy") : "--"}
        </span>
      ),
    },
  ];

  return (
    <>
      <div className={styles.card}>
        <div className={styles.recordLabel}>
          {briefInfluencers?.pagination?.totalCount || 0} Records found
        </div>
        <Row
          gutter={[15, 15]}
          justify={"space-between"}
          style={{ padding: "20px 10px" }}
        >
          <Col>
            <Search
              value={filters.searchQuery}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, searchQuery: e.target.value }))
              }
              placeholder="Search by influencer or username"
            />
          </Col>
        </Row>
        <Divider style={{ marginBottom: 20, marginTop: 0 }} />

        <Flex style={{ padding: "0px 10px 10px", gap: 6 }} wrap>
          <Tag
            color={filters.isBrandFavourite === true ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isBrandFavourite: prev.isBrandFavourite ? undefined : true,
              }))
            }
          >
            Favourite ({searchFacets?.isBrandFavourite})
          </Tag>
          <Tag
            color={
              filters.isInitialInfluencerCostPending ? "geekblue" : "default"
            }
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isInitialInfluencerCostPending:
                  prev.isInitialInfluencerCostPending ? undefined : true,
                isNewCommericalRequested: undefined,
                isInitialBrandCostPending: undefined,
                isCreatorOnboardPending: undefined,
              }))
            }
          >
            Influencer Commercials Pending (
            {searchFacets?.isInitialInfluencerCostPending})
          </Tag>

          <Tag
            color={filters.isInitialBrandCostPending ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isInitialBrandCostPending: prev.isInitialBrandCostPending
                  ? undefined
                  : true,
                isInitialInfluencerCostPending: undefined,
                isNewCommericalRequested: undefined,
                isCreatorOnboardPending: undefined,
              }))
            }
          >
            Awaiting Brand Price ({searchFacets?.isInitialBrandCostPending})
          </Tag>

          <Tag
            color={
              filters.isCreatorOnboardPending === true ? "geekblue" : "default"
            }
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isCreatorOnboardPending:
                  prev.isCreatorOnboardPending === undefined ? true : undefined,
                isInitialInfluencerCostPending: undefined,
                isNewCommericalRequested: undefined,
                isInitialBrandCostPending: undefined,
              }))
            }
          >
            No Contact ({searchFacets?.isCreatorOnboardPending})
          </Tag>

          <Divider
            type="vertical"
            style={{
              margin: "0px",
              backgroundColor: "var(--border-primary)",
              height: "unset",
            }}
          />
          <Tag
            color={filters.isDeliverablesPending ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isDeliverablesPending: prev.isDeliverablesPending
                  ? undefined
                  : true,
              }))
            }
          >
            Deliverable Pending ({searchFacets?.isDeliverablesPending})
          </Tag>
          <Divider
            type="vertical"
            style={{
              margin: "0px",
              backgroundColor: "var(--border-primary)",
              height: "unset",
            }}
          />

          <Tag
            color={filters.isBrandDeclined ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isBrandDeclined: prev.isBrandDeclined ? undefined : true,
              }))
            }
          >
            Brand Rejected ({searchFacets?.isBrandDeclined})
          </Tag>

          <Tag
            color={filters.isCreatorDeclined ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isCreatorDeclined: prev.isCreatorDeclined ? undefined : true,
              }))
            }
          >
            Influencer Rejected ({searchFacets?.isCreatorDeclined})
          </Tag>
        </Flex>
        <div style={{ position: "relative" }}>
          <Table
            dataSource={briefInfluencers?.data}
            size="small"
            loading={isFetching}
            columns={columns}
            rowKey={(record) => record._id}
            scroll={{ x: "max-content", y: 400 }}
            pagination={{
              pageSize: pageSize,
              current: page,
              total: briefInfluencers?.pagination?.totalCount,
              onChange: handlePageChange,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  setBriefIdOnly(record.briefId);
                },
              };
            }}
          />
        </div>

        {/* Drawer for selecting/creating deliverables */}
        {/* <Drawer
          title="Select Deliverable"
          open={
            deliverableModalProps.visible &&
            deliverableModalProps.type === "create"
          }
          onClose={() => {
            setDeliverableModalProps({
              visible: false,
              type: "create",
              deliverableId: "",
              briefInfluencerIds: [],
              briefId: "",
            });
            setSelectedDeliverableForAttach(null);
          }}
          width={800}
          destroyOnClose
          bodyStyle={{ padding: 0 }}
          footer={
            <Flex
              justify="flex-end"
              style={{
                padding: "16px 24px",
                // borderTop: "1px solid #f0f0f0",
                position: "sticky",
                bottom: 0,
                background: "#fff",
                zIndex: 10,
              }}
            >
              <Button
                type="primary"
                disabled={!selectedDeliverableForAttach}
                title={
                  selectedDeliverableForAttach
                    ? ""
                    : "Please select a deliverable."
                }
                loading={isAttaching}
                onClick={() => {
                  if (selectedDeliverableForAttach) {
                    attachBriefDeliverable({
                      deliverableId: selectedDeliverableForAttach._id,
                      briefInfluencerIds:
                        deliverableModalProps.briefInfluencerIds || [],
                    });
                  }
                }}
              >
                Attach
              </Button>
            </Flex>
          }
        >
          {deliverableModalProps.visible &&
            deliverableModalProps.type === "create" && (
              <CampaignDeliverables
                showTitle={false}
                selectedDeliverableId={brief?.defaultDeliverableV2Id}
                isEditable={true}
                briefInfluencerIds={deliverableModalProps.briefInfluencerIds}
                onClose={() =>
                  setDeliverableModalProps({
                    visible: false,
                    type: "create",
                    deliverableId: "",
                    briefInfluencerIds: [],
                    briefId: "",
                  })
                }
                onSelectedDeliverableChange={(deliverable) => {
                  setSelectedDeliverableForAttach(
                    deliverable ? { _id: deliverable._id || "" } : null
                  );
                }}
              />
            )}
        </Drawer> */}

        {/* Modal for viewing/editing deliverable packages */}
        {/* <Modal
          title={
            deliverableModalProps.type === "view"
              ? "View Deliverable"
              : "Edit Deliverable"
          }
          open={
            deliverableModalProps.visible &&
            deliverableModalProps.type === "view"
          }
          onCancel={() =>
            setDeliverableModalProps({
              visible: false,
              type: "create",
              deliverableId: "",
              briefInfluencerIds: [],
              briefId: "",
            })
          }
          footer={null}
          width={800}
          destroyOnClose
        >
          {deliverableModalProps.type === "view" && (
            <DeliverablePackageCard
              briefId={deliverableModalProps?.briefId || ""}
              onClose={() =>
                setDeliverableModalProps({
                  visible: false,
                  type: "create",
                  deliverableId: "",
                  briefInfluencerIds: [],
                  briefId: "",
                })
              }
              deliverableId={deliverableModalProps.deliverableId || ""}
              defaultDeliverableId={brief?.defaultDeliverableV2Id}
              showMarkDefaultButton
            />
          )}
        </Modal> */}
        <Modal
          title={"Verify Contact"}
          open={conatcsModalProps.visible}
          onCancel={() =>
            setContactsModalProps({
              visible: false,
              briefInfluencerId: "",
              creatorInfo: undefined,
              conatcts: [],
              initialContact: null,
            })
          }
          footer={null}
          width={800}
          destroyOnClose
        >
          {conatcsModalProps.visible && conatcsModalProps.creatorInfo && (
            <SelectContact
              initialContact={conatcsModalProps.initialContact}
              briefInfluencerId={conatcsModalProps.briefInfluencerId || ""}
              onSuccess={(briefInfluencer: IBriefInfluencerV2) => {
                if (!conatcsModalProps.addContactOnly) {
                  setInfluencerModalProps({
                    visible: true,
                    briefInfluencer: briefInfluencer,
                    type: "create",
                  });
                }
              }}
              onClose={() =>
                setContactsModalProps({
                  visible: false,
                  briefInfluencerId: "",
                  creatorInfo: undefined,
                  conatcts: [],
                  addContactOnly: false,
                  initialContact: null,
                })
              }
              creatorInfo={conatcsModalProps.creatorInfo}
            />
          )}
        </Modal>
        <Modal
          title={
            infCommercialsModalProps.type === "create"
              ? "Create Influnencer Commericals"
              : infCommercialsModalProps.type === "view"
                ? "Edit Influnencer Commericals"
                : "Add new  Influnencer Commericals"
          }
          open={infCommercialsModalProps.visible}
          onCancel={() =>
            setInfluencerModalProps({
              visible: false,
              type: "create",
              briefInfluencer: undefined,
            })
          }
          footer={null}
          width={800}
          destroyOnClose
        >
          {infCommercialsModalProps.visible &&
            infCommercialsModalProps.briefInfluencer && (
              <InfluencerCommercial
                onClose={() =>
                  setInfluencerModalProps({
                    visible: false,
                    type: "create",
                    briefInfluencer: undefined,
                  })
                }
                briefInfluencer={infCommercialsModalProps.briefInfluencer}
                type={infCommercialsModalProps.type}
              />
            )}
        </Modal>
        <Modal
          title={"Add Brand Commericals"}
          open={brandCommercialsModalProps.visible}
          onCancel={() =>
            setBrandluencerModalProps({
              visible: false,
              briefInfluencer: undefined,
            })
          }
          footer={null}
          width={800}
          destroyOnClose
        >
          {brandCommercialsModalProps.visible &&
            brandCommercialsModalProps.briefInfluencer && (
              <BrandCommercial
                onClose={() =>
                  setBrandluencerModalProps({
                    visible: false,
                    briefInfluencer: undefined,
                  })
                }
                briefInfluencer={brandCommercialsModalProps.briefInfluencer}
                type={"create"}
              />
            )}
        </Modal>
      </div>
      <Drawer
        title="Influencer Details"
        open={selectedInfluencer.visible}
        width={1300}
        footer={null}
        destroyOnClose
        onClose={() =>
          setSelectedInfluencer({ visible: false, props: undefined })
        }
      >
        {selectedInfluencer.props?.creatorInfo && (
          <SocialMediaInfluencerComp
            creatorInfo={selectedInfluencer.props?.creatorInfo}
            socialMediaInfluencerReq={{
              username: {
                platform: selectedInfluencer.props?.platform || "",
                socialMediaUsername: selectedInfluencer.props?.username || "",
              },
              toOpenInfluencer: selectedInfluencer.props?.toOpenInfluencer,
            }}
          />
        )}
      </Drawer>

      <Modal
        open={pricingPocModalProps.visible}
        onCancel={() =>
          setPricingPocModalProps({
            visible: false,
            briefInfluencerId: [],
            selectedAssignedTo: undefined,
          })
        }
        footer={null}
        title="Assign Pricing POC"
        destroyOnClose
      >
        {pricingPocModalProps.visible && (
          <AssignPricingModal
            briefInfluencerId={pricingPocModalProps.briefInfluencerId}
            assignedTo={pricingPocModalProps.selectedAssignedTo}
            onConfirm={(
              briefInfluencerId: string[],
              assignedToUserId: string
            ) =>
              assignPricingPoc({
                briefInfluencerId,
                assignedToUserId,
              })
            }
            confirmLoading={isAssigning}
            onCancel={() =>
              setPricingPocModalProps({
                visible: false,
                briefInfluencerId: [],
                selectedAssignedTo: undefined,
              })
            }
          />
        )}
      </Modal>
    </>
  );
};

export default BriefDiscoveryTracking;
